import React, { useEffect } from 'react'
import { useElementSize } from '~hooks'
import * as Styled from './Table.styles'

export interface ComponentProps {
  isDynamic: boolean
  onRowsCount: (rows: number) => void
  cellHeight: number
  topOffset?: number
  minRows?: number
}

const DynamicRowsTableContainer: React.FC<ComponentProps> = ({ isDynamic, onRowsCount, cellHeight, topOffset = 0, minRows = 5, children }) => {
  const [tableContainerRef, { height }] = useElementSize()

  useEffect(() => {
    const rowsToFit = Math.floor((height - topOffset) / cellHeight)

    isDynamic && onRowsCount(Math.max(rowsToFit, minRows))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height])

  // Reset page size on unmount
  useEffect(
    () => () => {
      isDynamic && onRowsCount(minRows)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return <Styled.TableContainer ref={tableContainerRef}>{children}</Styled.TableContainer>
}

export default DynamicRowsTableContainer
